import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutAutoRateList extends Layout {
    layoutheaderAutoRateList: LayoutHeader;
    sourceRate: DataSource;
    tableRate: Table;
}
